import { ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { InputComponent } from '../controls/input/input.component';
import { ButtonComponent } from '../controls/button/button.component';
import { DateComponent } from '../controls/date/date.component';
import { LabelComponent } from '../controls/label/label.component';
import { PhonenumberComponent } from '../controls/phonenumber/phonenumber.component';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { SelectComponent } from '../controls/select/select.component';
import { AutocompleteComponent } from '../controls/autocomplete/autocomplete.component';
// import { InputButtonComponent } from '../controls/input-button/input-button.component';
import { ChipfullwidthComponent } from '../controls/chipfullwidth/chipfullwidth.component';
import { CheckboxComponent } from '../controls/checkbox/checkbox.component';
import { AttachmentDragDropComponent } from '../controls/attachment-DragDrop/attachment-DragDrop.component';
import { AttachmentComponent1 } from '../controls/attachment/attachment.component';

const componentMapper = {
  0: InputComponent,
  15: DateComponent,
  20: ButtonComponent,
  6: LabelComponent,
  25: PhonenumberComponent,
  11: SelectComponent,
  10: AutocompleteComponent,
  // 26: InputButtonComponent,
  16: ChipfullwidthComponent,
  5: CheckboxComponent,
  9: AttachmentDragDropComponent,
  14: AttachmentComponent1,
};

@Directive({ selector: '[dynamicField]' })
export class DynamicFieldComponent implements OnInit {
  private resolver = inject(ComponentFactoryResolver);
  private container = inject(ViewContainerRef);

  // @Input() field: Fields;
  @Input() field: Fields;
  @Input() group: UntypedFormGroup;
  componentRef: any;
  requiredBool = false;
  ngOnInit() {
    // const factory = this.resolver.resolveComponentFactory(
    //   componentMapper[this.field.type]
    // );

    //ngonit starts
    if (this.field) {
      console.log(this.field.type, 'fieldtype');

      this.componentRef = this.container.createComponent(componentMapper[this.field.type]);
      this.componentRef.instance.field = this.field;
      this.componentRef.instance.group = this.group;
      if (this.field?.validations?.length > 0) {
        for (let index = 0; index < this.field?.validations.length; index++) {
          if (this.field?.validations[index].name == 'required') this.requiredBool = true;
          break;
        }
      } else {
        this.requiredBool = false;
      }
      this.componentRef.instance.requiredBool = this.requiredBool;
    }
    //ngonit ends
  }
}
